




























































import Vue from "vue";
import VFaIcon from "../VFaIcon.vue";
import _ from "lodash";
import { mapGetters } from "vuex";
import moment from "moment";

export default Vue.extend({
    components: { VFaIcon },
    data() {
        return {
            sendedDataRange: [],
            currentDateRange: [],
            applied: false,
            radioGroup: -1,
            comboboxSelections: [],
        };
    },
    props: {
        dateRange: [],
        description: String,
    },
    computed: {
        ...mapGetters(["userDateFormat"]),
        _() {
            return _;
        },

        radios() {
            return [
                {
                    text: this.$t("common.withinTheLast"),
                    value: 0,
                    combobox: true,
                },
                {
                    text: this.$t("common.moreThan"),
                    value: 1,
                    combobox: true,
                },
                {
                    text: this.$t("common.selectDateRange"),
                    value: 2,
                },
            ];
        },

        someChanges() {
            let changes = false;
            if (this.sendedDataRange.length != this.currentDateRange.length) changes = true;
            this.sendedDataRange.forEach((element) => {
                if (this.currentDateRange.filter((c) => c == element).length != 1) changes = true;
            });
            this.currentDateRange.forEach((element) => {
                if (this.sendedDataRange.filter((c) => c == element).length != 1) changes = true;
            });
            return changes;
        },
        today() {
            let temp: Date = new Date();
            return temp.toISOString().substring(0, 10);
        },
        date7DaysAgo() {
            let temp: Date = new Date();
            temp.setDate(new Date().getDate() - 7);
            return temp.toISOString().substring(0, 10);
        },
        date1MonthAgo() {
            let temp: Date = new Date();
            temp.setMonth(new Date().getMonth() - 1);
            return temp.toISOString().substring(0, 10);
        },
        date3MonthsAgo() {
            let temp: Date = new Date();
            temp.setMonth(new Date().getMonth() - 3);
            return temp.toISOString().substring(0, 10);
        },
        date6MonthsAgo() {
            let temp: Date = new Date();
            temp.setMonth(new Date().getMonth() - 6);
            return temp.toISOString().substring(0, 10);
        },
        date1YearAgo() {
            let temp: Date = new Date();
            temp.setFullYear(new Date().getFullYear() - 1);
            return temp.toISOString().substring(0, 10);
        },
        date2YearsAgo() {
            let temp: Date = new Date();
            temp.setFullYear(new Date().getFullYear() - 2);
            return temp.toISOString().substring(0, 10);
        },
        date2000() {
            return "2000-01-01";
        },

        comboboxItems() {
            return [
                {
                    text: this.$t("common.1week"),
                    value: this.date7DaysAgo,
                },
                {
                    text: this.$t("common.1month"),
                    value: this.date1MonthAgo,
                },
                {
                    text: this.$t("common.3months"),
                    value: this.date3MonthsAgo,
                },
                {
                    text: this.$t("common.6months"),
                    value: this.date6MonthsAgo,
                },
                {
                    text: this.$t("common.1year"),
                    value: this.date1YearAgo,
                },
                {
                    text: this.$t("common.2years"),
                    value: this.date2YearsAgo,
                },
            ];
        },

        sendedDataRangeLabel() {
            if (this.sendedDataRange.length != 2) return "-";
            else {
                let sortedArray = _.sortBy(this.sendedDataRange);
                return "from " + moment(sortedArray[0]).format(this.userDateFormat) + " to " + moment(sortedArray[1]).format(this.userDateFormat);
            }
        },

        currentDataRangeLabel() {
            if (this.currentDateRange.length != 2) return "-";
            else {
                let sortedArray = _.sortBy(this.currentDateRange);
                return "from " + moment(sortedArray[0]).format(this.userDateFormat) + " to " + moment(sortedArray[1]).format(this.userDateFormat);
            }
        },
    },
    watch: {
        radioGroup() {
            this.updateCurrentDateRange();
        },

        comboboxSelections() {
            this.updateCurrentDateRange();
        },
    },
    methods: {
        updateCurrentDateRange() {
            let startDate = null;
            let endDate = null;

            if (this.radioGroup == 0) {
                // within
                startDate = this.comboboxSelections[this.radioGroup];
                endDate = this.today;
            } else if (this.radioGroup == 1) {
                // more than
                startDate = this.date2000;
                endDate = this.comboboxSelections[this.radioGroup];
            }

            if (startDate && endDate) this.currentDateRange = [startDate, endDate];
        },

        reset() {
            this.radioGroup = -1;
            this.comboboxSelections = [];
            this.radios.forEach((radio) => {
                if (radio.combobox) this.comboboxSelections.push(this.comboboxItems[0].value);
                else this.comboboxSelections.push(null);
            });
        },

        onApply() {
            this.sendedDataRange = this.currentDateRange;
            let sortedDates = _.sortBy(this.currentDateRange);
            let endDate: Date = new Date(sortedDates[1]);
            endDate.setUTCHours(23, 59, 59);
            let datesToReturn = [sortedDates[0], endDate];
            this.$emit("input", _.sortBy(datesToReturn));
            this.applied = true;
        },
    },
    mounted() {
        this.reset();
    },
});
